/* Ladies Who Lit — featured product grid shuffle.
 *
 * Each homepage product grid renders a pool of products from its collection;
 * lwl-brand.css shows only the first four. This script reorders the pool so
 * the four on show vary between visits.
 *
 * Why client-side: Shopify collections have no random sort order, and
 * server-rendered pages sit behind a full-page cache, so anything seeded in
 * Liquid would be pinned for the life of the cache entry. Reordering in the
 * browser is the only way to get genuine per-visit variety.
 *
 * Degrades cleanly: with JavaScript off, CSS still shows the first four.
 */
(function () {
  'use strict';

  function shuffle(items) {
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var swap = items[i];
      items[i] = items[j];
      items[j] = swap;
    }
    return items;
  }

  function shuffleList(list) {
    var items = Array.prototype.slice.call(
      list.querySelectorAll(':scope > .resource-list__item')
    );
    if (items.length < 3) return;

    // Reordering by re-appending keeps every node and its listeners intact,
    // so Horizon's card behaviour (hover gallery, quick add) still works.
    var fragment = document.createDocumentFragment();
    shuffle(items).forEach(function (item) {
      fragment.appendChild(item);
    });
    list.appendChild(fragment);
    list.setAttribute('data-lwl-shuffled', 'true');
  }

  function run(root) {
    var main = document.querySelector('main[data-template="index"]');
    if (!main) return;
    var scope = root && main.contains(root) ? root : main;
    scope.querySelectorAll('.resource-list--grid').forEach(shuffleList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  // Re-shuffle when the theme editor re-renders a section.
  document.addEventListener('shopify:section:load', function (event) {
    run(event.target);
  });
})();
